import { useMutation } from '@tanstack/react-query';
import { generateOrderDocument, type OrderDocumentType } from '@api/orders';

export interface GenerateOrderDocumentVariables {
  orderId: number;
  documentType: OrderDocumentType;
}

export function useGenerateOrderDocument() {
  return useMutation({
    mutationFn: ({ orderId, documentType }: GenerateOrderDocumentVariables) =>
      generateOrderDocument(orderId, documentType),
  });
}
